import { DeveloperAccessService } from '@api/services/developer/service';
import { useState } from 'react';
import { Button } from '@trussworks/react-uswds';
import { FormProvider } from 'react-hook-form';
import { ResponseStatuses } from '@src/utils/enums';

const formatMessage = (message) => {
  if (!message) return null;

  const [heading, variables] = message.includes(':') ? message.split(':') : [message, ''];

  const envList = variables
    ? variables.split(',').map((variable, index) => <li key={index}>{variable.trim()}</li>)
    : null;

  return (
    <div className='margin-top-2'>
      <p>
        {heading}
        {variables && ':'}
      </p>{' '}
      <ul>{envList}</ul>
    </div>
  );
};

const EnvironmentVariablesCheck = () => {
  const [statusMessage, setStatusMessage] = useState(null);

  const handleSubmit = async () => {
    const result = await DeveloperAccessService.hasRequiredEnvironmentVariables();
    if (result.status === ResponseStatuses.Success) {
      setStatusMessage({ status: result.status, message: result.msg });
    } else {
      setStatusMessage({ status: 'Error', message: result.msg });
    }
  };

  return (
    <FormProvider>
      <div>
        <Button className='dev-dashboard-btn' title='Check Environment Variables' size='small' onClick={handleSubmit}>
          Check Environment Variables
        </Button>
      </div>
      {statusMessage && formatMessage(statusMessage?.message)}
    </FormProvider>
  );
};

export default EnvironmentVariablesCheck;
